document.addEventListener("DOMContentLoaded", function () {
  //accordionScroll()
});

// gsap.registerPlugin(ScrollTrigger);

// // General settings for all components
// const time = 0.5; // Duration of animation for each section
// const offset = 80; // Offset for vertical positioning

// // Loop over each stack wrapper for multiple components
// document.querySelectorAll(".stack_wrapper").forEach((stackWrapper) => {

//   // Calculate the menubar dynamically for each wrapper based on the number of items in .stack_items li
//   const menubar = 60 * stackWrapper.querySelectorAll(".stack_items li").length;

//   // Select all stack sections within this wrapper
//   const stackSections = stackWrapper.querySelectorAll(".stack_section");

//   // Set initial position for each stack section within its wrapper
//   gsap.set(stackSections, {
//     y: (index) => offset * index + menubar, // Set initial offset dynamically for each section
//     transformOrigin: "bottom top",
//   });

//   // Calculate start and end positions dynamically
//   const stackHeight = stackWrapper.offsetHeight;
//   const startPos = `top top-=${60 * stackWrapper.querySelectorAll(".stack_items li").length}px`;
//   const endPos = `+=${stackHeight}`;

//   // Timeline for ScrollTrigger animation
//   const tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: stackWrapper,
//       start: startPos,
//       end: endPos, // Dynamically calculate the end position based on each stack wrapper
//       scrub: 0.2, // Smooth scrubbing, adjust as needed
//       pin: true, // Pin the wrapper during scroll
//       markers: false, // Optional: Set to true for debugging (shows start and end markers)
//     },
//   });

//   // Animate stack sections when they enter the viewport
//   tl.from(stackSections, {
//     y: (index, target) => target.getBoundingClientRect().height + (offset * index),
//     duration: time / 2,
//     stagger: time / 1,
//     ease: "none", // No easing for smooth scrubbing
//   });

// });




function accordionScroll() {
  const allScrollComponents = document.querySelectorAll(".ps-accordian-folder-section");
  allScrollComponents.forEach(component => {
    let listItems = component.querySelectorAll(".accordion-trigger");
    let totalitemscount = listItems.length;
    listItems.forEach((item, index) => {
      totalitemscount--;
      item.setAttribute("role", "button");
      item.setAttribute("aria-expanded", "false");
      item.setAttribute("aria-controls", `accordion${index + 1}`);
      item.setAttribute("aria-label", `Expand section ${index + 1}`);

      // Function to handle scrolling
      function handleScroll(event) {
        event.preventDefault(); // Prevents form from submitting
        let targetSection = item.closest(".stack_section");


        if (targetSection) {
          const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY;
          let distanceToScroll = window.innerHeight - ((listItems.length - index)*60);
           distanceToScroll = item.getBoundingClientRect().top - ((listItems.length - index)*60);
         // console.log(distanceToScroll, listItems.length, index,item.getBoundingClientRect().top)
          // window.scrollTo({
          //   top: distanceToScroll,
          //   behavior: "smooth"
          // });
          window.scrollBy({
            top: distanceToScroll, // Scroll up by one full viewport height
            behavior: "smooth", // Smooth scrolling effect
          });
          const isExpanded = item.getAttribute("aria-expanded") === "true";
          item.setAttribute("aria-expanded", !isExpanded);
          item.setAttribute("aria-label", !isExpanded ? `Collapse section ${index + 1}` : `Expand section ${index + 1}`);
        }
      }

      // Click event
      item.addEventListener("click", handleScroll);
      // Keyboard event (Enter key)
      item.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          handleScroll(event);
        }
      });
    });
  });
};


document.querySelectorAll('.accordion-trigger').forEach(trigger => {
  trigger.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default anchor behavior
  });
});
